import { render, staticRenderFns } from "./StaffDashboardTableRow.vue?vue&type=template&id=4f6732cc&scoped=true&"
import script from "./StaffDashboardTableRow.vue?vue&type=script&lang=js&"
export * from "./StaffDashboardTableRow.vue?vue&type=script&lang=js&"
import style0 from "./StaffDashboardTableRow.vue?vue&type=style&index=0&id=4f6732cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6732cc",
  null
  
)

export default component.exports